"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedTableCell = exports.LoadingRow = exports.StyledTableFooter = exports.StyledTableHead = exports.StyledTableRow = exports.CustomTableContainer = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const styled_components_1 = __importDefault(require("styled-components"));
const CustomToolTip_1 = __importDefault(require("../interactions/CustomToolTip"));
const SimpleTable = ({ dataFetching, initData, isPageLoading, dataKey = "data", colWidth, paramKey, tooltips = {}, noPagination = false }) => {
    const params = (0, react_router_dom_1.useParams)();
    const searchParams = new URLSearchParams(window.location.search);
    const [loading, SetLoading] = (0, react_1.useState)(true);
    const [data, setData] = (0, react_1.useState)(null);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(parseInt(searchParams.get("page")) || 0);
    const [tableParam, setTableParam] = (0, react_1.useState)({ totalNumber: 0, page: parseInt(searchParams.get("page")) || 0, limit: 0 });
    const [didRender, setDidRender] = (0, react_1.useState)(false);
    const [rowPerPage, setRowPerPage] = (0, react_1.useState)(10);
    const [cols, setCols] = (0, react_1.useState)();
    const handlePage = (event, page) => {
        setCurrentPage(page);
    };
    const handleRowPerPage = (event) => {
        const rpp = parseInt(event.target.value);
        if (tableParam?.totalNumber < rpp * currentPage) {
            setCurrentPage(0);
        }
        setRowPerPage(rpp);
    };
    (0, react_1.useEffect)(() => {
        SetLoading(isPageLoading);
    }, [isPageLoading]);
    (0, react_1.useEffect)(() => {
        if (initData) {
            setData(initData.data);
            setTableParam({
                totalNumber: initData.totalNumber,
                page: initData.page,
                limit: initData.limit,
            });
        }
    }, [initData]);
    const updateData = async () => {
        SetLoading(true);
        let updatedData;
        if (paramKey) {
            updatedData = await dataFetching(params[paramKey], currentPage + 1, rowPerPage);
        }
        else {
            updatedData = await dataFetching(currentPage + 1, rowPerPage);
        }
        setData(updatedData[dataKey]);
        SetLoading(false);
    };
    (0, react_1.useEffect)(() => {
        const col = [];
        if (data && data[0]) {
            Object.keys(data[0])?.map((e, i) => {
                col.push({
                    id: e,
                    label: e,
                    childs: typeof data[0][e] === 'object' ? data[0][e] : null,
                    i: i,
                });
            });
        }
        setCols(col);
        setDidRender(true);
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (didRender) {
            updateData();
        }
    }, [currentPage, rowPerPage]);
    if (data) {
        return (react_1.default.createElement(exports.CustomTableContainer, { colWidth: colWidth },
            react_1.default.createElement(material_1.TableContainer, { sx: { borderTopLeftRadius: '25px', borderTopRightRadius: '25px' } },
                react_1.default.createElement(material_1.Table, null,
                    react_1.default.createElement(exports.StyledTableHead, null,
                        react_1.default.createElement(exports.StyledTableRow, null, cols.map((e, i) => {
                            return (react_1.default.createElement(exports.ThemedTableCell, { key: `${e.label}-${i}`, i: cols.length },
                                react_1.default.createElement("div", { style: { display: 'flex', gap: 8 } },
                                    e.label,
                                    tooltips[e.label] && react_1.default.createElement(CustomToolTip_1.default, { description: tooltips[e.label] }))));
                        }))),
                    react_1.default.createElement(material_1.TableBody, null, data.map((e, i) => {
                        return (react_1.default.createElement(exports.StyledTableRow, { key: `${e}-${i}.${i}` }, Object.keys(e).map((el, j) => {
                            return Object.keys(e[el]).map((ele, k) => {
                                return (react_1.default.createElement(exports.ThemedTableCell, { key: `${ele}-${k}`, i: cols.length }, e[el][ele]));
                            });
                            // }
                        })));
                    })),
                    react_1.default.createElement(exports.StyledTableFooter, { style: { borderBottom: '0px' } },
                        react_1.default.createElement(material_1.TableRow, null, !noPagination && (react_1.default.createElement(material_1.TablePagination, { sx: { color: '#fafafa' }, rowsPerPage: rowPerPage, count: tableParam.totalNumber, page: currentPage, onPageChange: handlePage, onRowsPerPageChange: handleRowPerPage }))))))));
    }
};
exports.default = SimpleTable;
exports.CustomTableContainer = (0, styled_components_1.default)('div') `
  font-family: 'Monserrat', sans-serif;
  font-weight: 400;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.radius.md};
  height: fit-content;
  grid-column: span ${(props) => props.colWidth?.xl};
  th {
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
    font-size: 1em;
    color: ${(props) => props.theme.colors.table.text};
  }
  td {
    font-size: 1em;
    color: ${(props) => props.theme.colors.table.text};
  }
  ${(props) => props.theme.media.lg} {
    grid-column: span ${(props) => props.colWidth.lg};
  }
  ${(props) => props.theme.media.md} {
    grid-column: span ${(props) => props.colWidth.md};
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span ${(props) => props.colWidth.sm};
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span ${(props) => props.colWidth.xs};
  }

  .amount {
    display: flex;
    width: max-content;
    > div {
      display: inherit;
    }
  }
`;
exports.StyledTableRow = (0, styled_components_1.default)(material_1.TableRow)(({ theme }) => ({
    color: theme.colors.table.text,
    fontSize: '1em',
    // padding: `0 ${theme.spacing.margin.md}`,
    '&:nth-of-type(odd)': {
        backgroundColor: theme.colors.table.odd,
        color: theme.colors.table.text,
        border: 'none',
        td: {
            border: 'none',
            color: theme.colors.table.text,
        },
        // padding: "4px",
        a: {
            color: theme.colors.onBg,
            textDecoration: 'none',
        },
    },
    '&:nth-of-type(even)': {
        backgroundColor: theme.colors.table.even,
        border: 'none',
        td: {
            border: 'none',
            color: theme.colors.table.text,
        },
        // padding: "3px",
        a: {
            color: theme.colors.table.text,
            textDecoration: 'none',
        },
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': {
        backgroundColor: theme.colors.table.hover,
    },
}));
exports.StyledTableHead = (0, styled_components_1.default)(material_1.TableHead)(({ theme }) => ({
    display: 'table-header-group',
    backgroundColor: theme.colors.table.header,
    color: theme.colors.table.text,
    borderTopRightRadius: '20px',
    borderTopLeftRadius: '20px',
    height: '70px',
    tr: {
        backgroundColor: `transparent !important`,
    },
    th: {
        backgroundColor: 'transparent',
        color: theme.colors.table.text,
        textTransform: 'capitalize',
    },
}));
exports.StyledTableFooter = (0, styled_components_1.default)(material_1.TableFooter)(({ theme }) => ({
    fontSize: '1em',
    fontFamily: 'Monserrat, sans-serif',
    fontWeight: 400,
    color: theme.colors.table.text,
    td: {
        border: 'none',
        fontSize: '1em',
        fontFamily: 'Monserrat, sans-serif',
        fontWeight: 400,
        color: theme.colors.table.text,
    },
}));
exports.LoadingRow = (0, styled_components_1.default)(material_1.TableRow) `
  height: 60px;
  width: 100%;
  margin: 5px 0;
`;
exports.ThemedTableCell = (0, styled_components_1.default)(TableCell_1.default) `
  padding: 10px 25px !important;
  min-width: 50px;
  width: ${(props) => 100 / props.i}vw;
  max-width: ${(props) => 100 / props.i}vw;
  ${(props) => props.theme.media.lg} {
    width: ${(props) => 100 / props.i}vw;
    max-width: ${(props) => 100 / props.i}vw;
  }
  ${(props) => props.theme.media.md} {
    width: ${(props) => 100 / props.i}vw;
    max-width: 300px;
  }
  ${(props) => props.theme.media.sm} {
    width: ${(props) => 100 / props.i}vw;
    max-width: 300px;
  }
  ${(props) => props.theme.media.xs} {
    max-width: 300px;
  }
`;
